import { render, staticRenderFns } from "./paperconfig.vue?vue&type=template&id=485a464e&scoped=true&"
import script from "./paperconfig.vue?vue&type=script&lang=js&"
export * from "./paperconfig.vue?vue&type=script&lang=js&"
import style0 from "./paperconfig.vue?vue&type=style&index=0&id=485a464e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a464e",
  null
  
)

export default component.exports